/**
 * Perfil del trabajador (T044 · US4). El sufijo `_` la convierte en ruta hermana de
 * `/trabajadores`: `_app/trabajadores.tsx` no renderiza `<Outlet/>` (igual que `sedes_.$siteId`).
 */
import { createFileRoute } from '@tanstack/react-router';

import { WorkerDetailPage } from '../../features/workers/worker-detail-page';

export const Route = createFileRoute('/_app/trabajadores_/$workerId')({
  component: function WorkerDetailRoute() {
    const { workerId } = Route.useParams();
    return <WorkerDetailPage workerId={workerId} />;
  },
});
